// @flow
import env from '../../environment';
import {getCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_FEATURE_USAGE: `${env.baseApiUrl}/im/admin/store-feature/usage`,
});
export const getFeatureUsageApi = getCreator(endpoints.GET_FEATURE_USAGE);
